import React from 'react'
import { Button, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useDrawer } from '../../providers/DrawerProvider';

const CustomButton = styled(Button)(({theme}) => ({
  backgroundColor: 'var(--cta)',
  fontFamily: 'GothamBold !important',
  border: '2px dashed var(--white)',
  padding: '0.5rem 3rem',
  fontSize: '1.15rem',
  boxShadow: 'none',
  
  '&:hover': {
    backgroundColor: 'var(--cta-dark)',
    boxShadow: 'none',
  },
}))

export const CTA = (props) => {
  const matches = useMediaQuery('(max-width: 768px)');
  const { setOpenDrawer, setFormPanel } = useDrawer();

  const drawerHandler = (method = 'register') => {
    setFormPanel(method);
    setOpenDrawer(true);
  }

  return (
    <CustomButton
      variant='contained'
      fullWidth={matches}
      onClick={props.drawer && (() => drawerHandler(props.drawer))}
      {...props}
    >
      {props.children || 'Cadastre-se'}
    </CustomButton>
  )
}
